module.exports = __webpack_public_path__ + "assets/img/VERSUSBET.5525b88c.png";